import Landmark from "@core/scripts/components/landmark-adapter";
import {intervalOver} from "../../helper/interval.js";

const WIDGET_SELECTOR = 'uclw_wrapper';
const CHECK_INTERVAL = 1000;
const CHECK_DURATION = 30000;
let fitFinderWidgetObserver;
let sendCloseLandmark = false;
let viewLandmarkSent = false;
let intervalId;

function enable(shopId, styleId, itemId) {
    isFitFinderAvailable(itemId).then(() => {
        if (!viewLandmarkSent) {
            viewLandmarkSent = true;
            Landmark.sendLandmark({
                landmark: 'action',
                view: 'adp_fit',
            });
        }
    }).catch(() => {
        disable();
    });

    if (!fitFinderWidgetObserver) {
        const mutationObserverCallback = createMutationObserverCallback(shopId, styleId);
        fitFinderWidgetObserver = new MutationObserver(mutationObserverCallback);
        fitFinderWidgetObserver.observe(document.body, {childList: true});
    }
}

function disable() {
    clearInterval(intervalId);
    if (fitFinderWidgetObserver) {
        fitFinderWidgetObserver.disconnect();
        fitFinderWidgetObserver = undefined;
    }
}

function createMutationObserverCallback(shopId, styleId) {
    return (mutationRecords) => {
        const childList = mutationRecords.find((element) => element.type === 'childList');

        childList?.addedNodes.forEach((node) => {
            if (node.id === WIDGET_SELECTOR) {
                Landmark.sendUserInterfaceLandmark({
                    click: 'adp_fit_open',
                    clickoverview: `fit_${shopId}_${styleId}`,
                });
            }
        });

        childList?.removedNodes.forEach((node) => {
            if (!sendCloseLandmark) {
                sendCloseLandmark = true;
                return;
            }
            if (node.id === WIDGET_SELECTOR) {
                Landmark.sendUserInterfaceLandmark({click: 'adp_fit_close'});
            }
        });
    };
}

function isFitFinderAvailable(itemId) {
    return new Promise((resolve, reject) => {
        intervalId = intervalOver(CHECK_DURATION, CHECK_INTERVAL, (terminate) => {
            const hasCurrentItemFitFinder = window._fitAnalytics?.widget?.products &&
                Object.keys(window._fitAnalytics.widget.products).some(key => {
                    const match = key.match(/-(\d+)$/);
                    const result = match[1];
                    return result === itemId.toString();
                });
            if (hasCurrentItemFitFinder) {
                terminate();
                resolve();
            }
        }, () => {
            reject();
        });
    });
}

export default {
    enable,
    disable
}
